import { useTheme } from "@emotion/react";
import Divider from "@mui/material/Divider";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import ToolTip from "../tooltip";
import Input from "./inputs/input";
import InputPassword from "./inputs/input_password";

export default function FormInputRecord({
	name,
	label,
	description = null,
	type = "text",
	multi_line = false,
	rows = 1,
	placeholder = "",
	no_divider = false,
	password_allow_show = false,
	password_allow_copy = false,
	disabled = false,
	required = false,
	children = null,
	size = null,
	end_adornment = null,
	dense = false,
	tip = null,
	alignItems = "center",
}) {
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

	return (
		<>
			<Grid
				container
				alignItems={alignItems}
				sx={{ mt: 3, pb: { md: dense ? 1 : 3, xs: 1 }, width: "100%" }}
			>
				<Grid item xs={12} md={5}>
					<Grid container>
						<Grid item xs={12}>
							<FormLabel sx={{ display: "flex", fontWeight: description ? 500 : 400 }} id={name}>
								{label}{" "}
								{required && (
									<Typography sx={{ color: "error.main", fontSize: 14, ml: 0.5 }}>*</Typography>
								)}
								{tip && <ToolTip tip={tip} sx={{ ml: 1 }} />}
							</FormLabel>
						</Grid>

						{description && (
							<Grid item xs={12} sx={{ mt: 0.25 }}>
								<Typography fontSize={14}>{description}</Typography>
							</Grid>
						)}
					</Grid>
				</Grid>

				<Grid item xs={12} md={7} sx={{ mt: { md: 0, xs: 1.5 } }}>
					{(() => {
						if (children) {
							return children;
						}
						if (type === "password") {
							return (
								<InputPassword
									copy={password_allow_copy}
									show={password_allow_show}
									name={name}
									label={label}
									placeholder={placeholder}
									sx={{ width: "100%" }}
									disabled={disabled}
									size={size}
								/>
							);
						}

						return (
							<Input
								name={name}
								label={isSmallScreen ? "" : label}
								placeholder={placeholder}
								sx={{ width: "100%" }}
								multi_line={multi_line}
								rows={rows}
								disabled={disabled}
								size={size}
								end_adornment={end_adornment}
							/>
						);
					})()}
				</Grid>
			</Grid>

			{!no_divider && <Divider sx={{ display: { md: "block", xs: "none" } }} />}
		</>
	);
}
